import TypesafeI18n from "i18n/i18n-react"
import { Provider } from "react-redux"
import { StackerContext } from "./StackerContext"
import PropTypes from "prop-types"

const DYApp = ({
  lang,
  store,
  retailerId,
  children,
  context = this,
  gender,
}) => {
  return (
    <TypesafeI18n locale={lang}>
      <Provider store={store}>
        <StackerContext.Provider
          value={{
            getInstance: () => context,
            retailerId: retailerId,
            lang: lang,
            gender: gender,
          }}
        >
          {children}
        </StackerContext.Provider>
      </Provider>
    </TypesafeI18n>
  )
}

DYApp.propTypes = {
  lang: PropTypes.string,
  store: PropTypes.any,
  retailerId: PropTypes.string,
  children: PropTypes.any,
  context: PropTypes.object,
  gender: PropTypes.string,
}

export default DYApp
